<div class="flex flex-col gap-3">
  @if (header != '') {
  <span class="text-lg">{{header}}:</span>
  }
  <div class="flex {{custom_class ? custom_class : 'flex-col'}} gap-5">
    @for (label_text of label_list; track label_text) {
    <label (click)="toggle_selection(label_text)" [ngClass]="{
          'opacity-50 cursor-not-allowed': is_disabled(),
          'cursor-pointer': !is_disabled()
        }" class="flex items-center group w-fit">
      <div [ngClass]="{
            'bg-primary border-pribg-primary': is_item_checked(label_text),
            'bg-white border-slate-300': !is_item_checked(label_text),
          }" class="w-5 h-5 border rounded transition-all duration-300 flex items-center justify-center overflow-hidden">
        @if (is_item_checked(label_text)) {
        <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5 text-white" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
        }
      </div>
      <span class="ml-3 text-sm font-medium text-slate-700 group-hover:text-pribg-primary transition-colors">{{ label_text }}</span>
    </label>
    }
  </div>
</div>